// /* Utils Initialiser */
// import { qs, qsa, addGlobalEventListener } from './utils.js'

/* eslint-disable */


// enter view
var enter = document.querySelectorAll(".enter");
if (enter) {
    enterView({
        selector: '.enter',
        enter: function (el) {
        el.classList.add('entered');
        },
        exit:function (el) {
          el.classList.remove('entered');
        },
        offset: 0.1,
        once: true,
    });
}



function mobileMenu(e) {
  e.classList.toggle('active');
  document.querySelector('.mobile_menu').classList.toggle('active');
}




// // Page navigation
var page_navigation = document.querySelector('.page-navigation');
if (page_navigation != null) {
  var page_sections = document.querySelectorAll('.anchor-section');
  for (let i = 0; i < page_sections.length; i++) {
    const s = page_sections[i];
    var id = s.id;
    page_navigation.innerHTML += '<li><a href="#' + id + '" aria-label="' + id + '">' + id + '</a></li>';
  }
}





/* Swiper Initialiser */
const swiperContainerP = document.getElementsByClassName('carousel_product')
for (var i = 0; i < swiperContainerP.length; i++) {
  swiperContainerP[i].classList.add('swiperP' + i)

  const swiperPage = swiperContainerP[i].querySelector('.swiper-pagination');
  const swiperNext = swiperContainerP[i].querySelector('.swiper-next');

  if (swiperNext) {
    swiperNext.classList.add('nextP' + i)
  }
  if (swiperPage) {
    swiperPage.classList.add('pageP' + i)
  }

  var mySwiperP = new Swiper('.swiperP' + i, {
    direction: 'horizontal',
    loop: false,
    autoHeight: false,
    slidesPerView: 1,
    speed: 300,
    loop: true,
    centeredSlides: true,
    effect: "fade",
    // pagination: {
    //   el: '.pageP' + i,
    //   clickable: true,
    // },
    navigation: {
      nextEl: swiperNext,
    },
  })
}

/* Toggle Class (Generic) */
function toggleClass(modalName) {
  var modalActive = document.querySelector(modalName)
  modalActive.classList.toggle('active')
}

/* Change Product Quantity */
function changeQuantity(formId, quantity) {
	var formQ = document.querySelector(formId)

	if (quantity == '+') {
		Number(formQ.value++)
	} else if (quantity == '-' && formQ.value > 1) {
		Number(formQ.value--)
	}
  console.log(formQ.value);
}

/* Open Cart */
function cartOpen() {
  document.querySelector('body').classList.add('js-my-cart-open');
}

/* Details Animator */
const details = document.querySelectorAll('details')

if (details) {
  details.forEach((targetDetail) => {
    targetDetail.addEventListener('click', function (e) {
      if (targetDetail.hasAttribute('open')) {
        e.preventDefault()
        targetDetail.classList.add('closing')
        setTimeout(() => {
          targetDetail.removeAttribute('open')
          targetDetail.classList.remove('closing')
        }, 390)
      }
    })
  })
}

/* Orphan Remove and LSEP Removal */
var nbspSelectors = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'a', 'span']
var nbspWordMin = 10 //Minimum words within parent tag to activate script

// nbspSelectors.forEach(function (selector) {
//   var nbspElements = document.querySelectorAll(selector)
//   nbspElements.forEach(function (element) {
//     element.innerHTML = element.innerHTML.replace(/\u2028/g, '')
//     element.innerHTML = element.innerHTML.replace(/&#8232;/g, '')
//     var wordCount = element.innerHTML.split(' ').length
//     if (wordCount >= nbspWordMin) {
//       element.innerHTML = element.innerHTML.replace(/ ([^ ]*)$/, '&nbsp;$1')
//     }
//   })
// })

/* Lazy Load Initialiser */
var lazyLoadInstance = new LazyLoad({})

/* Close Announcement Bar */

// const annoucenmentCloseBtn = document.querySelector('#closeAnnouncementBar')

// annoucenmentCloseBtn.addEventListener('click', (e) => {
//   e.currentTarget.parentElement.classList.add('hidden')

//   //TODO add in local state for remembering announcemnet bar
// })





// section clicks

  // product information
  function infoProd(e) {

    var target = e.dataset.name;
    var parent = e.closest('.product-information');
    var selectors = parent.querySelectorAll('.pi-selector');

    var btns = parent.querySelectorAll('.buttons-btn');
    for (let i = 0; i < btns.length; i++) {
      const btn = btns[i];
      btn.classList.remove('active')
    }
    e.classList.add('active')

    for (let i = 0; i < selectors.length; i++) {
      var s = selectors[i];
      if (s.dataset.name == target) {
        s.classList.add('active');
      } else {
        s.classList.remove('active');
      }
    }
    
  }


  // instagram 
  var swiper = new Swiper(".ig-slider", {
    slidesPerView: 1.2,
    spaceBetween: 20,
    breakpoints: {
      640: {
        slidesPerView: 3,
        spaceBetween: 40,
      }
    }
  });

  

  // PLP
  var filterList = []
  function checkBox(evt) {
      evt.classList.toggle('active');
      var target = evt.dataset.name;

      // filterList.push(target);


      if (!filterList.includes(target)){         
          filterList.push(target);       
      } else {
          filterList.splice(filterList.indexOf(target), 1); 
      }
  
      var products = document.querySelectorAll('.pcard');
      if (filterList != "") {
       
          products.forEach(function(p) {
              filterList.forEach(function(entry) {
                  if( !p.classList.contains(entry)){
                      p.classList.add('visually-hidden');
                  } else {
                      p.classList.remove('visually-hidden');
                  }
              });
          });
      } else {
          products.forEach(function(p) {
              p.classList.remove('visually-hidden');
          })
      }




  }



  function collectionButton(e) {
      var target = e.dataset.name;
      var button_lists = document.querySelectorAll('.collection-button-list');
      for (let i = 0; i < button_lists.length; i++) {
          const list = button_lists[i];
          if (list.dataset.name == target) {
              list.classList.add('active');
          } else {
              list.classList.remove('active');
          }
      }

      var triggers = document.querySelectorAll('.collection-list-trigger');
      for (let i = 0; i < triggers.length; i++) {
          const t = triggers[i];
          t.classList.remove('active')
      }
      e.classList.add('active')
  }





  // sessionStorage.setItem("layout", "tile");
  let dataLayout = sessionStorage.getItem("layout");
  if (dataLayout == null && document.querySelector('.collection__grid') != null) {
    document.querySelector('.collection__grid').classList.remove('tiles');
    document.querySelector('.view-btn[data-name="tile"]').classList.add('active');
  }



  function collectionView(e) {
      var layout = e;
      var triggers = document.querySelectorAll('.view-btn');
      for (let i = 0; i < triggers.length; i++) {
          const t = triggers[i];
          t.classList.remove('active');
          var target = t.dataset.name
          // t.classList.remove('active');
          if (layout == "tile") {
            document.querySelector('.collection__grid').classList.remove('grid');
            document.querySelector('.collection__grid').classList.add('tiles');
            sessionStorage.setItem("layout", "tile");
          } else {
           
              document.querySelector('.collection__grid').classList.add('grid');
              document.querySelector('.collection__grid').classList.remove('tiles');
              sessionStorage.setItem("layout", "grid");
          }
          if (t.dataset.name == layout) {
              t.classList.add('active');
          }
      }
  }
  collectionView(dataLayout);






  function sortBtns() {
      var srtBtns = document.querySelectorAll('.sort-list a');
      var pageURL = window.location.href.split('?sort_by=');
      if (pageURL[1] == "price-ascending") {
          document.querySelector('.lowtohigh').classList.add('active');
      } else if (pageURL[1] == "price-descending") {
          document.querySelector('.hightolow').classList.add('active');

      }
  }
  sortBtns()